import { TableRow, Table } from '@insurancemenu/imenu-components-lib';
import { capitalize, dateFormatters } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { ModalType } from 'global/utils/ModalsHelper';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRFQProductTemplatesStore } from 'store/pages/rfq/rfq-template/rfq-product-templates/pageStore';
import { ProductTemplateBC } from 'types/productServiceV2';
import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import { RATE_SEGMENT_TITLES } from 'global/utils/RateSegmentHelper';
import {
  StatusTagStyled,
  TableBodyRowStyled,
  TableBodyStyled,
  TableCellStyled,
  TableHeaderStyled,
  TableHeadingStyled,
  TableWrapperStyled,
} from './styles';
import { PRODUCT_TEMPLATES_INFO_MODAL_TABLE_TEST_ID, PRODUCT_TEMPLATES_INFO_MODAL_TEST_ID } from '../../constants';

const TemplateInfoModal = observer((): JSX.Element => {
  const { isTemplateInfoModalOpen, currentProductTemplate, closeTemplateInfoModal } = useRFQProductTemplatesStore();

  const convertedCurrentTemplate = toJS(currentProductTemplate);

  if (!convertedCurrentTemplate) return <></>;

  const {
    id,
    name,
    internalName,
    effectiveFrom,
    effectiveTo,
    createdOn,
    createdBy,
    productLineId,
    filterBC,
    status,
    rateSegment,
  } = convertedCurrentTemplate;

  const bcObject: Record<string, string> = {};

  Object.keys(filterBC).forEach((key) => {
    const convertedKey = capitalize(key);
    bcObject[convertedKey] = filterBC[key as keyof ProductTemplateBC]?.join(', ') || '';
  });

  const templateInfo = {
    'IM Product Id': id,
    'Internal Name': internalName || name,
    'External Name': name,
    'Rate Segment': RATE_SEGMENT_TITLES[rateSegment],
    Status: <StatusTagStyled status={status} />,
    'Product Line': PRODUCT_LINES_CONTENT_MAP[productLineId]?.label,
    'Effective Date Range': `${dateFormatters.normDateToShortAmericanDate(
      effectiveFrom,
    )}-${dateFormatters.normDateToShortAmericanDate(effectiveTo)}`,
    'Creation Date': dateFormatters.normDateToShortAmericanDate(createdOn),
    'Created By': createdBy.name,
    ...bcObject,
  };

  const rowsList = Object.entries(templateInfo).map(([key, value]) => (
    <TableBodyRowStyled key={key}>
      <TableCellStyled>{key}</TableCellStyled>
      <TableCellStyled>{value}</TableCellStyled>
    </TableBodyRowStyled>
  ));

  return (
    <ActionModal
      show={isTemplateInfoModalOpen}
      title="Full Template Information"
      subtitle="Essential Information on the Template Provided for Reference"
      modalType={ModalType.NO_ICON}
      closeButtonText="Close"
      onClose={closeTemplateInfoModal}
      modalContent={
        <TableWrapperStyled>
          <Table
            data-test-id={PRODUCT_TEMPLATES_INFO_MODAL_TABLE_TEST_ID}
            totalElements={Object.entries(templateInfo).length}
          >
            <TableHeaderStyled>
              <TableRow>
                <TableHeadingStyled>Parameter</TableHeadingStyled>
                <TableHeadingStyled>Value</TableHeadingStyled>
              </TableRow>
            </TableHeaderStyled>
            <TableBodyStyled>{rowsList}</TableBodyStyled>
          </Table>
        </TableWrapperStyled>
      }
      data-test-id={PRODUCT_TEMPLATES_INFO_MODAL_TEST_ID}
    />
  );
});

export default TemplateInfoModal;
